export const backendConfigUrl = '/config/config.json';

const CONFIG = {
  debugMode: false,
  development: {
    userProfile: {
      requireLogin: true,
    },
  },
  backend: {
    feeds: {
      login: `/login`,
      logout: `/logout`,
      validate: `/validate`,
      register: `/register`,
      instanceConfig: `/config`,
      mailingLists: `/mailing/list`,
      mailingListsAll: `/mailing/list-all`,
      userProfile: `/user`,
      passwordRecovery: `/password/send-request`,
      recoverPasswordChange: `/password/recovery`,
      verifyPasswordChangeToken: `/password/verify-token`,
      verifyEmailVerificationToken: `/verify-user`,
      passwordChange: `/user/change-password`,
      unsubscribeMailingLists: `/unsubscribe`,
      anonymousAuth: `/anonymous-auth`,
    },
  },
};

export default CONFIG;



// WEBPACK FOOTER //
// ./build-config/prod.js